import { useState } from 'react';

import { ProfileReservation } from '@assets/icons';
import { DateType } from '@utils/dateUtil';
import ResponsiveApplyButton from '@components/views/components/listing/drawer/ResponsiveApplyButton/ResponsiveApplyButton';
import ResponsiveSearchDrawerItem from '@components/views/components/listing/drawer/ResponsiveSearchDrawerItem';
import ResponsiveSearchInputDrawer from '@components/views/components/listing/drawer/ResponsiveSearchInputDrawer/ResponsiveSearchInputDrawer';
import { LocationAnimationErrorBox } from '@components/views/components/listing/ListingStyle';
import { FlightSearchInputDrawerType } from '@components/views/flight/types';
import ResponsiveSingleDatePicker from '@components/DatePicker/SingleDatePicker/ResponsiveSingleDatePicker';
import { DayPickerSingleDateControllerProps } from '@components/DatePicker/SingleDatePicker/SingleDatePicker';

import { getSingleDatePickerPlaceholder } from './utils';

const searchLabel = 'Gidiş Tarihiniz?';

const ResponsiveSingleDateSelectDrawer = ({
  date,
  onDateChange,
  title,
  subTitle,
  placeholder,
  drawerTitle,
  arrowIcon,
  error,
}: Pick<DayPickerSingleDateControllerProps, 'date' | 'onDateChange'> &
  FlightSearchInputDrawerType & { error?: boolean }) => {
  return (
    <ResponsiveSearchInputDrawer
      icon={ProfileReservation}
      title={title}
      subTitle={subTitle}
      placeholder={placeholder}
      drawerTitle={drawerTitle}
      arrowIcon={arrowIcon}
    >
      {(hideModal) => (
        <ResponsiveSingleDateSelect
          date={date}
          onDateChange={onDateChange}
          hideModal={hideModal}
          error={error}
        />
      )}
    </ResponsiveSearchInputDrawer>
  );
};

const ResponsiveSingleDateSelect = ({
  date,
  onDateChange,
  hideModal,
  error,
}: Pick<DayPickerSingleDateControllerProps, 'date' | 'onDateChange'> & {
  hideModal: () => void;
  error?: boolean;
}) => {
  const [localDate, setLocalDate] = useState<DateType | null>(date);

  const handleDateChange = (date: DateType | null) => {
    setLocalDate(date);
  };

  const inputSubTitle = getSingleDatePickerPlaceholder(localDate);

  const onSubmit = () => {
    if (localDate) {
      onDateChange(localDate);
      setLocalDate(null);
      hideModal();
    }
  };

  return (
    <>
      <LocationAnimationErrorBox hasError={error || false}>
        <ResponsiveSearchDrawerItem
          icon={ProfileReservation}
          title={searchLabel}
          subTitle={inputSubTitle}
          placeholder='Gidiş Tarihi'
        />
      </LocationAnimationErrorBox>

      <ResponsiveSingleDatePicker
        date={localDate}
        onDateChange={handleDateChange}
      />

      <ResponsiveApplyButton onClick={onSubmit} />
    </>
  );
};

export default ResponsiveSingleDateSelectDrawer;
